export default "__VITE_ASSET__DinqW9ns__"